// core
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'raptorPhone'
})
export class RaptorPhonePipe implements PipeTransform {

  transform(country: any, phone: string): string {
    if (!country || !phone) {
      return '';
    }

    const formattedValue = phone.replace(/^0|^/, `+${ country }`);
    
    return formattedValue;
  }

}
